// src/components/Courses.js
import React, { useState, useEffect } from "react";
import "./Courses.css"; // Import the CSS file
import axios from "axios";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");

  useEffect(() => {
    axios.get("/api/courses")
      .then(response => {
        setCourses(response.data);
        setFilteredCourses(response.data);
      })
      .catch(error => console.error("Error fetching courses:", error));
  }, []);

  useEffect(() => {
    const filtered = courses.filter(course => {
      return (
        (categoryFilter === "" || course.category === categoryFilter) &&
        (searchTerm === "" || course.name.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    });
    setFilteredCourses(filtered);
  }, [searchTerm, categoryFilter, courses]);

  const handleAddCourse = (course) => {
    axios.post("/api/courses", course)
      .then(response => {
        setCourses([...courses, response.data]);
        setFilteredCourses([...filteredCourses, response.data]);
        setShowAddModal(false);
      })
      .catch(error => console.error("Error adding course:", error));
  };

  const categories = [...new Set(courses.map(course => course.category))]; // Unique categories

  return (
    <div className="courses-list">
      <h1>Courses</h1>

      {/* Filters */}
      <div className="filters">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select
          onChange={(e) => setCategoryFilter(e.target.value)}
          value={categoryFilter}
        >
          <option value="">All Categories</option>
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      {/* Course Cards */}
      {filteredCourses.map((course) => (
        <div className="course-card" key={course.id} onClick={() => setShowViewModal(course)}>
          <h3 className="course-title">{course.name}</h3>
          <p>Description: {course.description}</p>
          <p>Price: ${course.price}</p>
          <p>Category: {course.category}</p>
        </div>
      ))}
      <button onClick={() => setShowAddModal(true)} className="btn-success">
        Add New Course
      </button>

      {/* Add Course Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="modal-close" onClick={() => setShowAddModal(false)}>
              &times;
            </span>
            <h2>Add New Course</h2>
            <AddCourseForm onSave={handleAddCourse} />
          </div>
        </div>
      )}

      {/* View Course Modal */}
      {showViewModal && (
        <div className="modal-overlay" onClick={() => setShowViewModal(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="modal-close" onClick={() => setShowViewModal(null)}>
              &times;
            </span>
            <h2>{showViewModal.name}</h2>
            <p><strong>Description:</strong> {showViewModal.description}</p>
            <p><strong>Price:</strong> ${showViewModal.price}</p>
            <p><strong>Category:</strong> {showViewModal.category}</p>
            <p><strong>Duration:</strong> {showViewModal.duration} weeks</p>
          </div>
        </div>
      )}
    </div>
  );
};

const AddCourseForm = ({ onSave }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [duration, setDuration] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const newCourse = { name, description, price, category, duration };
    onSave(newCourse);
  };

  return (
    <form onSubmit={handleSubmit} className="add-course-form">
      <div>
        <label>Course Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Price</label>
        <input
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Category</label>
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Duration (weeks)</label>
        <input
          type="number"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn-primary">
        Save Course
      </button>
    </form>
  );
};

export default Courses;


// // src/components/Coursesz.js
// import React, { useState } from "react";
// import "./Courses.css"; // Import the CSS file

// const Coursesz = () => {
//   const [courses, setCourses] = useState([
//     {
//       id: 1,
//       name: "React for Beginners",
//       price: "Free",
//       category: "Web Development",
//       duration: 4,
//       shortDescription: "Learn the basics of React.",
//       fullDescription:
//         "This course will cover the basics of React, including components, state, and props. It's perfect for beginners!",
//     },
//     {
//       id: 2,
//       name: "Advanced React",
//       price: "$49.99",
//       category: "Web Development",
//       duration: 6,
//       shortDescription: "Dive deeper into React.",
//       fullDescription:
//         "This course is for those who want to dive deeper into React. Learn about hooks, context API, and more!",
//     },
//   ]);

//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [selectedCourse, setSelectedCourse] = useState(null);

//   const handleAddCourse = (course) => {
//     setCourses([...courses, { ...course, id: courses.length + 1 }]);
//     setShowAddModal(false);
//   };

//   const handleViewDetails = (course) => {
//     setSelectedCourse(course);
//     setShowDetailsModal(true);
//   };

//   return (
//     <div className="course-list">
//       <h1>Courses</h1>
//       {courses.map((course) => (
//         <div className="course-card" key={course.id}>
//           <h2>{course.name}</h2>
//           <p>Category: {course.category}</p>
//           <p>Duration: {course.duration} weeks</p>
//           <p>{course.shortDescription}</p>
//           <p>Price: {course.price}</p>
//           <button onClick={() => handleViewDetails(course)} className="btn-primary">
//             View Course
//           </button>
//         </div>
//       ))}
//       <button onClick={() => setShowAddModal(true)} className="btn-success">
//         Add New Course
//       </button>

//       {/* Add Course Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <span className="modal-close" onClick={() => setShowAddModal(false)}>&times;</span>
//             <h2>Add New Course</h2>
//             <AddCourseForm onSave={handleAddCourse} />
//           </div>
//         </div>
//       )}

//       {/* View Course Details Modal */}
//       {showDetailsModal && (
//         <div className="modal-overlay" onClick={() => setShowDetailsModal(false)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <span className="modal-close" onClick={() => setShowDetailsModal(false)}>&times;</span>
//             {selectedCourse && (
//               <>
//                 <h2>{selectedCourse.name}</h2>
//                 <p>Category: {selectedCourse.category}</p>
//                 <p>Duration: {selectedCourse.duration} weeks</p>
//                 <p>Price: {selectedCourse.price}</p>
//                 <p>Short Description: {selectedCourse.shortDescription}</p>
//                 <p>Full Description: {selectedCourse.fullDescription}</p>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const AddCourseForm = ({ onSave }) => {
//   const [name, setName] = useState("");
//   const [price, setPrice] = useState("");
//   const [category, setCategory] = useState("");
//   const [duration, setDuration] = useState("");
//   const [shortDescription, setShortDescription] = useState("");
//   const [fullDescription, setFullDescription] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newCourse = { name, price, category, duration, shortDescription, fullDescription };
//     onSave(newCourse);
//   };

//   return (
//     <form onSubmit={handleSubmit} className="add-course-form">
//       <div>
//         <label>Course Name</label>
//         <input
//           type="text"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           required
//         />
//       </div>
//       <div>
//         <label>Price</label>
//         <input
//           type="text"
//           value={price}
//           onChange={(e) => setPrice(e.target.value)}
//           required
//         />
//       </div>
//       <div>
//         <label>Category</label>
//         <input
//           type="text"
//           value={category}
//           onChange={(e) => setCategory(e.target.value)}
//           required
//         />
//       </div>
//       <div>
//         <label>Duration (in weeks)</label>
//         <input
//           type="number"
//           value={duration}
//           onChange={(e) => setDuration(e.target.value)}
//           required
//         />
//       </div>
//       <div>
//         <label>Short Description</label>
//         <textarea
//           value={shortDescription}
//           onChange={(e) => setShortDescription(e.target.value)}
//           required
//         />
//       </div>
//       <div>
//         <label>Full Description</label>
//         <textarea
//           value={fullDescription}
//           onChange={(e) => setFullDescription(e.target.value)}
//           required
//         />
//       </div>
//       <button type="submit" className="btn-primary">
//         Save Course
//       </button>
//     </form>
//   );
// };

// export default Coursesz;
